module.exports = __webpack_public_path__ + "img/contact.0245c929.png";